import { easeInOutQuad as easeInOut } from '../../foundation/Easing'

class FadeText {
  constructor(el) {
    this.el = el
    this.top = 0
  }
  update(innerHeight) {
    const progress = Math.min(1, Math.max(0, ((-this.top + innerHeight * 0.75) / innerHeight) * 4))
    this.el.style.opacity = progress
    this.top = this.el.getBoundingClientRect().top
  }
}

export class RecruitIndexMessage {
  constructor() {
    this.el = document.getElementById('js-recruit-index-message')
    if (this.el === null) return
    this.timer
    this.startTime = performance.now()
    this.currentFrame = 0
    this.fadeTexts = null
    this.fadeTextInit(this.el.querySelector('.desc'))
    this.headerInit()
    this.loop()
  }
  headerInit() {
    const header = document.getElementById('js-header')
    if (header === null) return
    let isAct = false
    window.addEventListener('scroll', () => {
      const { scrollY } = window
      if (scrollY > 0) {
        if (!isAct) {
          isAct = true
          header.classList.add('is-act')
        }
      } else {
        if (isAct) {
          isAct = false
          header.classList.remove('is-act')
        }
      }
    })
  }
  fadeTextInit(desc) {
    // const descSpans = [...desc.children].filter((s) => s.tagName === 'SPAN')
    // descSpans.forEach((s) => {
    //   s.innerHTML = `<span>${s.textContent.split('').join('</span><span>')}</span>`
    // })
    const others = [...desc.parentNode.querySelectorAll('.js-fade')]

    this.fadeTexts = [...others.map((o) => new FadeText(o)), ...[...desc.children].filter((s) => s.tagName === 'SPAN').map((s) => new FadeText(s))]
  }
  frame(time, elapsedTime) {
    if (this.fadeTexts === null) return
    const innerHeight = window.innerHeight
    this.fadeTexts.forEach((fadeText) => {
      fadeText.update(innerHeight)
    })
  }
  loop(time) {
    this.timer = requestAnimationFrame(this.loop.bind(this))
    const elapsedTime = time - this.currentTime
    this.currentTime = time
    const tmpFrame = Math.floor((time - this.startTime) / (1000.0 / 60))
    if (this.currentFrame !== tmpFrame) {
      this.currentFrame = tmpFrame
      this.frame(time, elapsedTime)
    }
    const gbcr = this.el.getBoundingClientRect()
    const innerHeight = window.innerHeight
    const progress = -gbcr.top / innerHeight
    const percent = Math.min(1, Math.max(0, progress * 0.5))
    this.el.style.setProperty('--mag', easeInOut(percent))
  }
}
